


































import Vue from 'vue';
import moment from 'moment';
import customerClient from '../../apis';
import commonClient from '../../../common/apis';
import { TaskType } from '../../../common/models/TaskType';

export default Vue.extend({
  data() {
    return {
      remarkCount: 0,
      userCount: 0,
      syncing: false,
      interval: null,
      syncStart: false,
      syncSuccess: false,
      endAt: null,
    };
  },
  computed: {
    syncIcon(): string {
      if (this.syncSuccess) {
        return 'md-checkmark';
      } else {
        return '';
      }
    },
  },
  methods: {
    getRemarkInfo() {
      customerClient.getRemarkInfo({}).success((r: any) => {
        this.remarkCount = r.remarkCount;
        this.userCount = r.userCount;
      });
    },
    getCurrentSyncRemarkTask() {
      commonClient.getTasksByTypes({
        page: 1,
        size: 1,
        tpes: [10],
      }).success(r => {
        if (r.tasks && r.tasks.length > 0) {
          if (r.tasks[0]['result'] !== null) {
            if (this.syncStart) {
              this.syncSuccess = true;
              this.$emit('refresh');
            }
            this.syncStart = false;
            this.syncing = false;
            this.endAt = moment(r.tasks[0]['endAt']).fromNow();
          } else {
            this.syncing = true;
            this.syncStart = true;
            this.syncSuccess = false;
          }
        }
      });
    },
    createSyncRemarkTask() {
      commonClient.createTask({
        input: {
          SyncWxRemark: {},
        },
        taskType: TaskType.SyncWxRemark,
        expectCount: 0,
      }).success(r => {
        this.$Message.success('创建同步微信标签任务成功，请等待');
        this.syncing = true;
        this.syncStart = true;
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
  },
  mounted() {
    this.getRemarkInfo();
    this.getCurrentSyncRemarkTask();
    this.interval = setInterval(() => {
      this.getCurrentSyncRemarkTask();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
});
